import { Box, Stack } from '@mui/material'

import CattlesLogo from 'assets/CattlesLogo'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { BaseWidget } from '../../../baseWidget'

export const MilkyHerd = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { statistics, error, loading } = useWidgetStatistics()

	if (!permissions?.license_food_table || error) return null

	const milky = statistics?.herd?.milky

	return (
		<BaseWidget
			icon={
				<Box
					sx={{
						width: '24px',
						height: '24px',
						backgroundColor: COLORS.mainSecondaryOpacity,
						borderRadius: '50%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<CattlesLogo color={COLORS.main} width={18} height={18} />
				</Box>
			}
			path={'/cattles'}
			isLoading={loading}
		>
			<Stack direction='column' gap='8px'>
				<Stack direction='column' gap='4px'>
					{(milky || milky === 0) && (
						<TypographyPrimary16Bold>{milky}</TypographyPrimary16Bold>
					)}
					<TypographyPrimary>Дойных голов</TypographyPrimary>
				</Stack>
			</Stack>
		</BaseWidget>
	)
}
